module.exports = __webpack_public_path__ + "703be9c7a1504256b5ed164021edbb6b.png";